import { createSlice } from "@reduxjs/toolkit";
import { getVersionList, getOneVersionDocx, getLatestVersionDocs, updateTncPP, publishDoc } from "./tncThunk";

const initialState = {
  versionListSuccess: null,
  versionListErr: null,
  oneVersionSuccess: null,
  oneVersionErr: null,
  latestVersionSuccess: null,
  latestVersionErr: null,
  updateTncPpSuccess: null,
  updateTncPpErr: null,
  publishDocSuccess: null,
  publishDocErr: null,
};

const tncSlice = createSlice({
  name: "tncSlice",
  initialState,
  reducers: {
    resetGetVersionList(state) {
      state.versionListSuccess = null;
      state.versionListErr = null;
    },
    resetOneVersionDocx(state) {
      state.oneVersionSuccess = null;
      state.oneVersionErr = null;
    },
    resetLatestVersionDocx(state) {
      state.latestVersionSuccess = null;
      state.latestVersionErr = null;
    },
    resetUpdateTncPP(state) {
      state.updateTncPpSuccess = null;
      state.updateTncPpErr = null;
    },
    resetPublishDoc(state) {
      state.publishDocSuccess = null;
      state.publishDocErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL VERSION LIST
      .addCase(getVersionList.fulfilled, (state, action) => {
        state.versionListSuccess = action.payload;
      })
      .addCase(getVersionList.rejected, (state, action) => {
        state.versionListErr = action.error.message;
      })
      // GET ONE VERSION DATA
      .addCase(getOneVersionDocx.fulfilled, (state, action) => {
        state.oneVersionSuccess = action.payload;
      })
      .addCase(getOneVersionDocx.rejected, (state, action) => {
        state.oneVersionErr = action.error.message;
      })
      // GET LATEST VERSION DATA
      .addCase(getLatestVersionDocs.fulfilled, (state, action) => {
        state.latestVersionSuccess = action.payload;
      })
      .addCase(getLatestVersionDocs.rejected, (state, action) => {
        state.latestVersionErr = action.error.message;
      })
      // UPDATE LATEST VERSION DATA
      .addCase(updateTncPP.fulfilled, (state, action) => {
        state.updateTncPpSuccess = action.payload;
      })
      .addCase(updateTncPP.rejected, (state, action) => {
        state.updateTncPpErr = action.error.message;
      })
      //publish
      .addCase(publishDoc.fulfilled, (state, action) => {
        state.publishDocSuccess = action.payload;
      })
      .addCase(publishDoc.rejected, (state, action) => {
        state.publishDocErr = action.error.message;
      });
  },
});

export const { resetGetVersionList, resetOneVersionDocx, resetLatestVersionDocx, resetUpdateTncPP, resetPublishDoc } = tncSlice.actions;
export default tncSlice.reducer;
